export const storeProductsCache = new Map<string, any[]>();